import * as React from "react";
import { useCallback } from "react";
import { Input } from "components/bootstrap";
const createEvent = (name, value) => ({
  target: { name, value }
});
const NumericField = ({ onChange, value, error, name, title, field, inputHelp }) => {
  const _onChange = useCallback(
    (e) => {
      onChange(createEvent(e.target.name, Number.parseFloat(e.target.value)));
    },
    [onChange]
  );
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `${name}-input`,
      bsSize: "small",
      type: "number",
      name,
      onChange: _onChange,
      value: value != null ? value : "",
      label: title,
      error,
      placeholder: field.description,
      step: field.step,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      help: inputHelp
    }
  );
};
export default NumericField;
